<div #container class="d-flex align-items-stretch" style="flex: 1" [ngClass]="{'mb-0': modalOptions.fullScreen || showInReport, 'card': !showInReport, 'report-view': showInReport}">
    <ng-container *ngIf="!showInReport">
        <div class="card-header dropdown">
            <h4 class="card-header-title">
                <img src="assets/images/icons/ranking.png" width="20px" class="me-2">
                <span>{{entityType() | titlecase}} ranking</span>
                <span class="mx-2 notranslate">–</span>
                <span class="notranslate">{{measurementName(getSelectedDataType, true)}}</span>
                <span class="notranslate">&nbsp;</span>
                <span *ngIf="options.showBySquareMeter">per m²</span>
            </h4>
            <app-data-provider-date-range *ngIf="modalOptions.fullScreen"></app-data-provider-date-range>
            <app-chart-download-button [element]="container"></app-chart-download-button>
            <button type="button" class="btn" role="button" data-bs-toggle="dropdown"
                    data-bs-auto-close="outside" aria-expanded="false">
                <i class="bi bi-three-dots-vertical"></i>
            </button>
            <div class="dropdown-menu" style="z-index: 1050;">
                <div class="dropdown-item" *ngIf="perSquareMeterEnabled">
                    <div class="form-check">
                        <input class="form-check-input" type="checkbox" value="" [id]="getInputId('showBySquareMeter')"
                               [ngModel]="options.showBySquareMeter" (ngModelChange)="showBySquareMeterChange($event)">
                        <label class="form-check-label" [for]="getInputId('showBySquareMeter')">
                            Show by m²
                        </label>
                    </div>
                </div>
                <div class="dropdown-item">
                    <div class="row">
                        <label class="form-check-label col-auto" [for]="getInputId('measurementType')+'-select'">Measurement</label>
                        <app-select class="col px-0" [ngModel]="getSelectedDataType" (ngModelChange)="measurementTypeChanged($event)" [id]="getInputId('measurementType')"
                                    [options]="possibleDataTypes()" [small]="true" [formatter]="dropdownFormatter"></app-select>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
    <div class="chart-body pt-0 pb-0" [ngClass]="{'p-0': options.showAsTable, 'card-body': !showInReport}">
        <ng-container [ngTemplateOutlet]="chart"></ng-container>
    </div>
</div>

<ng-template #chart>
    <ng-container *ngIf="showInReport else normalView">
        <app-bar-chart class="chart h-100 w-100 small-chart" [stacked]="true" [y1AxisMeasurement]="measurementUnit()"
                       style="flex: 1;" [dataProvider]="chartDataProvider"
                       [selectedWeatherTypes]="options.selectedWeatherTypes" [weatherTypes]="weatherTypes"
                       [fullScreen]="modalOptions.fullScreen" [animationDuration]="showInReport ? 0 : 1000"
                       [horizontally]="true" [customOnClick]="navigateToEntity" [customHover]="onHover"
                       [topPadding]="showInReport ? -100 : 0" [directiveView]="this">
        </app-bar-chart>
    </ng-container>
    <ng-template #normalView>
        <app-pagination [maxPerPage]="pageSize" [items]="records" (pageChangeItems)="applyPaging($event)">
            <ng-container *ngIf="showChart; else loadingSkeleton">
                <app-bar-chart class="chart h-100 w-100" [stacked]="true" [y1AxisMeasurement]="measurementUnit()"
                               style="flex: 1" [dataProvider]="chartDataProvider"
                               [selectedWeatherTypes]="options.selectedWeatherTypes" [weatherTypes]="weatherTypes"
                               [fullScreen]="modalOptions.fullScreen" [animationDuration]="showInReport ? 0 : 500"
                               [horizontally]="true" [customOnClick]="navigateToEntity" [customHover]="onHover"
                               [directiveView]="this">
                </app-bar-chart>
            </ng-container>
            <ng-template #loadingSkeleton>
                <div class="pt-3">
                    <ngx-skeleton-loader count="1" [appearance]="'line'"
                                         [theme]="{ height: '300px', 'border-radius': '0.25rem' }">
                    </ngx-skeleton-loader>
                </div>
            </ng-template>
        </app-pagination>
    </ng-template>
</ng-template>